module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-835-retro.d3a54ee7.jpg";